// Styles
import { StyledCard, StyledSubTitle, StyledTitle } from './BannersPreviewStyles';

// Helpers
import { getImagePreview } from '../../helpers';

type TBannerCard = {
  title?: string;
  description?: string;
  link?: string;
  image?: string;
  isMobile?: boolean;
};

const Banner = ({ description, link, image, title, isMobile }: TBannerCard) => {
  const desktopImagePreview = getImagePreview(image);

  return (
    <StyledCard
      $image={desktopImagePreview as string}
      $isMobile={isMobile}
      as={link ? 'a' : 'div'}
      href={link || undefined}
      target={link ? '_blank' : undefined}
      rel={link ? 'noreferrer' : undefined}
    >
      {!!title && <StyledTitle $isMobile={isMobile}>{title}</StyledTitle>}
      {!!description && <StyledSubTitle $isMobile={isMobile}>{description}</StyledSubTitle>}
    </StyledCard>
  );
};

export default Banner;
